import React, { useState } from 'react';
import classNames from 'classnames';
import { ChevronDownOutlined } from 'jl-design-system/components/icons/ChevronDownOutlined';
import { sendEvent } from '@JohnLewisPartnership/experiments-utils';
import { PrenavMenu } from '../ui/prenav-menu/PrenavMenu';
import styles from './prenav-link.scss';
import { notifyNavAnalytics } from '../navigation/notify-analytics';

export const PrenavLink = props => {
  const clickHandler = e => {
    sendEvent(
      `prenav-menu-click.${e.target.innerHTML.replace(/ /g, '-').toLowerCase()}`
    );
    notifyNavAnalytics('pn', e.target.innerHTML);
  };

  const [showmenu, setShowmenu] = useState(false);

  return (
    <li
      className={classNames(
        styles.headerLinksContainer,
        styles.headerLinksContainer__prenav
      )}
      data-testid="prenav-redesign-container"
      onMouseEnter={() => setShowmenu(true)}
      onMouseLeave={() => setShowmenu(false)}
    >
      <>
        <a
          key={props.children}
          className={classNames(
            styles.headerLinkItem,
            styles.headerLinkItem__prenav,
            {
              [styles.underlinedHeaderLinkItem]: props.menuLinks.length === 0,
              [styles.underlinedHeaderLinkItem__prenav]:
                props.menuLinks.length === 0,
            }
          )}
          href={props.url || '#'}
          tabIndex={props.children ? 0 : -1}
          onClick={
            props.menuLinks.length > 0 ? e => e.preventDefault() : clickHandler
          }
          onKeyDown={e => {
            if (
              props.menuLinks.length > 0 &&
              (e.key === 'Enter' || e.key === ' ')
            ) {
              e.preventDefault();
              setShowmenu(prev => !prev);
            }
          }}
          {...(props.menuLinks.length > 0 && {
            'aria-haspopup': 'true',
            'aria-expanded': showmenu,
            'aria-controls': 'prenav-menu',
          })}
        >
          {props.children}
          {props.menuLinks.length > 0 && (
            <ChevronDownOutlined
              className={styles.menuChevronIcon}
              size="small"
            />
          )}
        </a>
        {showmenu && props.menuLinks.length > 0 && (
          <PrenavMenu
            {...props}
            itemClassName={classNames(styles.prenavLinkMenuBox, {
              [styles.prenavLinkMenuBox__prenav]: true,
            })}
            onClose={() => setShowmenu(false)}
          />
        )}
      </>
    </li>
  );
};
